define('views/shared/anthemaccountconverted/anthemaccountconverted',["backbone",
        "text!views/shared/anthemaccountconverted/anthemaccountconverted.html",
        "views/_base/baseview"
], function (Backbone, Template, BaseView) {
    "use strict";

    return BaseView.extend({
        template: _.template(Template),
        isRender: false,
        needsAuth: false,
        tagName: "section",
        id: "anthemAccountConverted",
        events: {},
        initialize: function (options) {
            options = options || {};


            this.ugid = options.ugid;
            this.code = options.code;
            this.elementName = options.elementName;
            BaseView.prototype.initialize(this);
        },
        render: function () {
            this.$el.html(this.template());

            return this;
        },
        loadData: function () {

            var that = this;
            $.ajax({
                type: "GET",
                url: pf.url + "/Join/" + this.ugid + "/" + this.code,
                contentType: "application/json; charset=utf-8",
                success: function (response) {
                    that.render();
                },
                error: function (response) {
                    that.render();
                }
            });
        },
        close: function () { }
    });
});


